import { motion } from "framer-motion";
import LogoWatermark from "./LogoWatermark";

const centers = [
  {
    id: 1,
    title: "Pune, India",
    image: "/assets/centers/bengaluru.jpg",
    contact: "Mr Alex Johnson",
    phone: "+91 9112195999",
    email: "info@ajpgroup.com",
    address:
      "Gat No. 257/258, Bhairavnath Industrial Estate, Kondhwa Budruk, Pune, Maharashtra 411048",
  },
  {
    id: 2,
    title: "Bengaluru, India",
    image: "/assets/centers/pune.png",
    contact: "Mr Shridhar Pawar",
    phone: "+91 99866 24530 / +91 99864 40948",
    email: "banagalore@ajpgroup.com",
    address:
      "Sy.Nos 38/1, 38/4, 38/5, MVIT College Road, next to Lamborghini Service Center, Nellukunte Village, Bettahalsuru Post, Bangalore – 562157",
  },
];

export default function PerformanceCenters() {
  return (
    <>
      {/* Workshops Section */}
      <section className="relative isolate overflow-hidden py-24 px-4 md:px-10">

        {/* Background image — flipped vertically like contact section */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url('/assets/contact.jpg')",
            transform: "scaleY(-1)",
          }}
        />

        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black/80" />

        {/* AJP logo watermark */}
        <LogoWatermark opacity={0.2} />

        {/* Content */}
        <div className="relative z-10">
          <div className="max-w-6xl mx-auto mb-14 text-center">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="text-3xl md:text-5xl font-semibold text-white"
            >
              Our Workshops
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.15 }}
              viewport={{ once: true }}
              className="text-gray-400 mt-4 text-base md:text-lg"
            >
              Strategically Located To Serve You Better.
            </motion.p>
          </div>

          {/* Cards */}
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
            {centers.map((center, index) => (
              <motion.div
                key={center.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                viewport={{ once: true }}
                whileHover={{ y: -6 }}
                className="bg-[#1A1A1A]/90 backdrop-blur-sm border border-white/[0.08] hover:border-[#C9A24D]/50 transition-colors duration-300 rounded-2xl overflow-hidden shadow-2xl flex flex-col group"
              >
                {/* Image */}
                <div className="h-56 overflow-hidden p-3">
                  <img
                    src={center.image}
                    alt={center.title}
                    className="w-full h-full object-cover rounded-xl transition-transform duration-700 group-hover:scale-105"
                  />
                </div>

                {/* Content */}
                <div className="px-7 pb-7 pt-2 flex flex-col flex-1 space-y-4">
                  <h3 className="text-2xl font-semibold text-white group-hover:text-red-400 transition-colors duration-300">
                    {center.title}
                  </h3>

                  <div className="space-y-3 text-sm text-gray-300 leading-7 flex-1">
                    <p>
                      <span className="font-medium text-gray-500">Contact:</span>{" "}
                      {center.contact}
                    </p>
                    <p>
                      <span className="font-medium text-gray-500">Phone:</span>{" "}
                      <a href={`tel:${center.phone.split("/")[0].replace(/\s/g, "")}`} className="hover:text-[#C9A24D] transition-colors">
                        {center.phone}
                      </a>
                    </p>
                    <p>
                      <span className="font-medium text-gray-500">Email:</span>{" "}
                      <a href={`mailto:${center.email}`} className="hover:text-[#C9A24D] transition-colors">
                        {center.email}
                      </a>
                    </p>
                    <p>
                      <span className="font-medium text-gray-400">Address:</span>
                      <br />
                      {center.address}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}